<template>
  <div class="setting-panel">
    <!-- 卡片一 -->
    <ul class="card">
      <li class="panel-item">
        <div class="title-wrapper">
          <span class="title">推荐偏好</span>
        </div>
        <div class="right-wrapper">
          <button
            type="button"
            class="btn-order-pay"
            :class="{ active: preference === '0' }"
            @click="handleClickPreference('0')"
          >
            价格最低
          </button>
          <button
            type="button"
            class="btn-order-pay"
            :class="{ active: preference === '1' }"
            @click="handleClickPreference('1')"
          >
            时效最快
          </button>
        </div>
      </li>
      <li class="panel-item">
        <div class="title-wrapper">
          <span class="title">清关类型</span>
        </div>
        <div class="right-wrapper">
          <button
            type="button"
            class="btn-order-pay"
            :class="{ active: type === '2' }"
            @click="handleClickChangeType('2')"
          >
            邮件清关
          </button>
          <button
            type="button"
            class="btn-order-pay"
            :class="{ active: type === '3' }"
            @click="handleClickChangeType('3')"
            v-show="preference !== '1'"
          >
            商业清关
          </button>
        </div>
      </li>
      <li class="panel-item">
        <div class="title-wrapper">
          <span class="title">特殊服务</span>
        </div>
        <div class="right-wrapper" @click="show = true">
          <span class="value" :class="{ 'has-value': value.length }">{{
            specialServiceValue || '请选择'
          }}</span>
          <i
            class="iconfont icon-arrow-right"
            :class="{ 'has-value': value.length }"
          />
        </div>
      </li>
    </ul>
    <!-- 卡片二 -->
    <ul class="card">
      <li class="panel-top-item">
        <div class="top-wrapper">
          <div class="title-wrapper">
            <span class="title">货币换算</span>
          </div>
          <div class="right-wrapper">
            <div class="exchangerate-box" @click="currencyPopup = true">
              <span class="currency">RMB</span>
              <img src="@/assets/images/change.svg" class="exchange" />
              <span class="currency">{{ currency }}</span>
              <i class="iconfont icon-arrow-down"></i>
            </div>
          </div>
        </div>
        <div class="bottom-wrapper">
          <span>¥</span>
          <input
            type="text"
            placeholder="输入人民币"
            class="input-box money-input"
            v-model.number="rmb"
          />
          <input
            type="text"
            :placeholder="exchangeCurrency"
            class="input-box money-input"
            disabled
          />
          <span class="unit">{{ currency }}</span>
          <button @click="handleChangeRate" class="change-btn">换算</button>
        </div>
      </li>
    </ul>
    <!-- 卡片三 -->
    <ul class="card">
      <li class="panel-item">
        <div class="title-wrapper">
          <span>重量</span>
          <i
            class="iconfont icon-question-circle-outline"
            @click="toIntroducePage('weight')"
          />
        </div>
        <div class="right-wrapper">
          <div class="computer-wrapper">
            <div class="reduce-wrapper" @click="handleClickWeight(-1)">
              <i class="iconfont icon-remove-circle-outline" />
            </div>
            <input
              class="reduce-text"
              type="text"
              :value="weight.toFixed(2)"
              @change="handleChangeWeight"
            />
            <span class="kg">{{ weightUnit }}</span>
            <div class="add-wrapper" @click="handleClickWeight(1)">
              <i class="iconfont icon-add-circle-outline" />
            </div>
          </div>
          <div class="weight-btn">
            <button
              type="button"
              class="btn-order-pay"
              :class="{ active: weightUnit === 'kg' }"
              @click="handleClickWeightUnit('kg')"
            >
              kg
            </button>
            <button
              type="button"
              class="btn-order-pay"
              :class="{ active: weightUnit === 'g' }"
              @click="handleClickWeightUnit('g')"
            >
              g
            </button>
          </div>
        </div>
      </li>
      <li class="panel-item" v-if="currentTab === 'sar'">
        <div class="title-wrapper">
          <span>保价</span>
          <i
            class="iconfont icon-question-circle-outline"
            @click="toIntroducePage('protect')"
          />
        </div>
        <div class="right-wrapper">
          <input
            class="input-style"
            :value="protectPrice"
            @input="handleInputProtectPrice"
            placeholder="填写寄递物品的实际价值"
            type="text"
          />
          <span class="is-unit">元</span>
        </div>
      </li>
      <li class="panel-item">
        <div class="title-wrapper">
          <span>内件类型</span>
        </div>
        <div class="right-wrapper">
          <button
            type="button"
            class="btn-order-pay"
            :class="{ active: innerParts === '3' }"
            @click="handleClickInnerParts('3')"
          >
            物品
          </button>
          <button
            type="button"
            class="btn-order-pay"
            :class="{ active: innerParts === '1' }"
            @click="handleClickInnerParts('1')"
          >
            文件
          </button>
        </div>
      </li>
      <li class="panel-top-item">
        <div class="top-wrapper">
          <div class="title-wrapper">
            <span>总体积</span>
            <i
              class="iconfont icon-question-circle-outline"
              @click="toIntroducePage('volume')"
            />
          </div>
        </div>

        <div class="bottom-wrapper pd-14">
          <input
            type="text"
            placeholder="长 cm"
            class="length-input-box"
            v-model.number="length"
            @change="handleChangeVom"
          />
          <span class="unit1">*</span>
          <input
            type="text"
            placeholder="宽 cm"
            class="length-input-box"
            v-model.number="width"
            @change="handleChangeVom"
          />
          <span class="unit1">*</span>
          <input
            type="text"
            placeholder="高 cm"
            class="length-input-box"
            v-model.number="height"
            @change="handleChangeVom"
          />
        </div>
      </li>
    </ul>

    <div class="loading-box" v-show="loading">
      <img src="@/assets/images/loading.gif" class="loading-img" alt="" />
    </div>
    <popup
      :show="show"
      title="特殊服务（可多选）"
      confirm-btn-text="确定"
      @close="show = false"
      @confirm="handleConfirm"
    >
      <selectList
        :list="list"
        :ismultiple="true"
        :value="value"
        ref="selectList"
      ></selectList>
    </popup>

    <!-- 货币换算列表 -->
    <popup
      :show="currencyPopup"
      title="选择币种"
      confirm-btn-text="确定"
      @close="currencyPopup = false"
      @confirm="handleConfirmCurrency"
    >
      <selectList
        :list="currencyList"
        :ismultiple="false"
        :value="currency"
        ref="currencyList"
      ></selectList>
    </popup>
  </div>
</template>
<script>
import { Button } from '@postui/postui'
import popup from '@/components/popup'
import selectList from '../selectList'
import { debounce } from '@/plugin/commonUse.js'
import { checkPostMoneyCodeApi, queryServiceRecommendApi } from '@/api/protocol'
import { PreciseCalculation } from '@/plugin/commonUse'
import { findCurrencyRateInfoNewApi } from '@/api/index'

export default {
  name: 'settingPanel',
  components: {
    [Button.name]: Button,
    popup,
    selectList
  },
  data () {
    return {
      preference: '0',
      type: '2',
      value: ['0'], // 特殊服务
      show: false,
      weightUnit: 'kg',
      weight: 1,
      innerParts: '3', // 1文件 3物品
      length: '',
      width: '',
      height: '',
      currencyPopup: false,
      currency: 'USD', // 币种
      list: [
        {
          label: '退回',
          value: '0'
        },
        {
          label: '保价/保险',
          value: '1'
        },
        {
          label: '一票多件',
          value: '2'
        },
        {
          label: '电池',
          value: '3'
        }
      ],
      currencyList: [
        {
          label: 'USD',
          value: 'USD'
        }
      ],
      exchangeRate: 0, // 汇率
      rmb: '', // 输入的人民币值
      exchangeCurrency: '0', // 目标金额转换的币值
      protectPrice: '', // 保价金额
      loading: false // 控制是否显示loading
    }
  },
  computed: {
    specialServiceValue () {
      let obj = {
        '0': '退回',
        '1': '保价',
        '2': '一票多件',
        '3': '电池'
      }
      return this.value.map(i => obj[i]).join(',')
    }
  },
  props: {
    countryUnit: {
      type: String,
      default: () => ''
    },
    sendInfo: {
      type: Object,
      default: () => {}
    },
    receInfo: {
      type: Object,
      default: () => {}
    },
    currentTab: {
      type: String,
      default: () => ''
    }
  },
  watch: {
    countryUnit (val) {
      if (val !== '') {
        this.getPostMoneyCode(val)
      }
    },
    currency () {
      this.queryExchangeRate()
    }
  },
  methods: {
    // 输入修改重量
    handleChangeWeight (e) {
      let value = e.target.value
      let reg = /^[-+]?\d+(\.\d+)?([eE][-+]?\d+)?$/
      if (reg.test(value)) {
        if (Number(value) < 1) {
          value = '1'
          this.weight = 0
          this.$nextTick(() => {
            this.weight = Number(Number(value).toFixed(2))
          })
        } else {
          this.weight = Number(Number(value).toFixed(2))
        }
        this.changeQueryParam()
        return
      }
      this.weight = 0
      this.$nextTick(() => {
        this.weight = 1
      })
    },
    // 推荐偏好切换点击事件
    handleClickPreference (value) {
      if (value === '1') {
        this.type = '2'
      }
      this.preference = value
      this.changeQueryParam()
    },

    // 清关类型切换点击事件
    handleClickChangeType (value) {
      this.type = value
      this.changeQueryParam()
    },

    // 重量单位切换点击事件
    handleClickWeightUnit (value) {
      this.weightUnit = value
      this.changeQueryParam()
    },

    // 内件类型切换点击事件
    handleClickInnerParts (value) {
      this.innerParts = value
      this.changeQueryParam()
    },

    // 体积值改变监听事件
    handleChangeVom () {
      this.changeQueryParam()
    },

    handleConfirm () {
      const selectList = this.$refs.selectList
      this.value = selectList.myValue
      this.show = false
      this.changeQueryParam()
    },
    handleClickWeight (step) {
      if (this.weight + step < 1) return
      this.weight = this.weight + step
      this.changeQueryParam()
    },
    // 请求货币接口
    async getPostMoneyCode (unit) {
      const res = await checkPostMoneyCodeApi({
        countryNo: unit
      })
      if (res.code === '000000' && res.info) {
        this.currencyList = res.info.map(item => ({
          label: item,
          value: item
        }))

        if (unit === 'HK' && res.info.includes('HKD')) {
          this.currency = 'HKD'
        } else {
          this.currency = 'USD'
        }
      }
    },
    handleConfirmCurrency () {
      const selectList = this.$refs.currencyList
      this.currency = selectList.myValue
      this.currencyPopup = false
      this.exchangeCurrency = '0'
      this.rmb = ''
    },
    async queryExchangeRate () {
      const res = await findCurrencyRateInfoNewApi({
        originalCurrencyCode: 'CNY',
        exchangeCurrencyCode: this.currency
      })
      if (res.code === '000000') {
        this.exchangeRate = res.info.exchangeRate
      } else {
        this.exchangeRate = 0
      }
    },
    handleChangeRate () {
      this.exchangeCurrency = PreciseCalculation.multiply(
        this.exchangeRate,
        this.rmb
      ).toFixed(2)
    },

    // 查询推荐服务产品
    async queryServiceRecommend (option) {
      let { userProvinceCode, userCityCode, userAreaCode } = this.sendInfo
      console.log('打印寄件人对象地址', this.sendInfo)
      let param = {
        senderProvCode: userProvinceCode,
        senderCityCode: userCityCode,
        senderCountyCode: userAreaCode,
        aACode: option.aACode,
        aAPostCode: option.aAPostCode,
        inner: this.innerParts,
        weight: this.weightUnit === 'kg' ? this.weight * 1000 : this.weight,
        length: this.length,
        width: this.width,
        height: this.height,
        service: this.value.join(','),
        sort: this.preference,
        insuranceAmount: this.protectPrice
      }
      // 如果是直辖市北京、上海、天津、重庆的省市值传同一个值
      if (['110000', '310000', '120000', '500000'].includes(userProvinceCode)) {
        param.senderCityCode = userProvinceCode
      }

      const res = await queryServiceRecommendApi(param)
      if (res.code === '000000') {
        // 处理 返回的数据
        return res.info
      } else {
        return false
      }
    },

    // 请求寄达地址参数处理
    getReceiveInfo () {
      console.log('receInfo', this.receInfo)
      return {
        aACode: this.receInfo.countryUnit,
        aAPostCode: this.receInfo.postCode || ''
      }
    },

    submitVerify () {
      if (!this.sendInfo.userProvinceCode) {
        this.$toast({
          message: '请选择寄件地址',
          iconClass: 'icon-hint'
        })
        return false
      }
      if (this.currentTab === 'land' && !this.receInfo.userProvinceCode) {
        this.$toast({
          message: '请选择收件地址',
          iconClass: 'icon-hint'
        })
        return false
      }
      if (this.currentTab !== 'land' && !this.receInfo.countryUnit) {
        this.$toast({
          message: '请选择收件地址',
          iconClass: 'icon-hint'
        })
        return false
      }
      return true
    },
    // 查询产品
    async getProductList () {
      if (!this.submitVerify()) {
        return false
      }
      if (this.loading) return
      this.loading = true
      let option = this.getReceiveInfo()
      let res = await this.queryServiceRecommend(option)
      this.loading = false
      if (res === false) {
        return false
      }
      let result = []
      let list = this.filterProductList(res, this.type)
      if (this.preference === '0') {
        result = this.sortByCondition(list, 'totalFee', 'time')
      } else {
        result = this.sortByCondition(list, 'time', 'totalFee')
      }
      return result
    },

    // 过滤出符合清关类型的产品
    filterProductList (list, mailType) {
      return list.filter(item => {
        return item.mailType === mailType
      })
    },

    /**
     * 对数组进行排序，首先按条件一从低到高，条件一相同时按条件二从低到高
     * @param {Array} arr - 要排序的数组对象
     * @param {string} firstCondition - 首要排序字段名，默认为 'totalFee'
     * @param {string} secondCondition - 次要字段名，默认为 'time'
     * @returns {Array} - 排序后的新数组
     */
    sortByCondition (
      arr,
      firstCondition = 'totalFee',
      secondCondition = 'time'
    ) {
      // 检查输入参数
      if (!Array.isArray(arr)) {
        throw new Error('第一个参数必须是一个数组')
      }

      if (arr.length === 0) {
        return []
      }

      // 创建数组的副本，避免修改原数组
      const sortedArray = [...arr]

      // 使用排序函数
      sortedArray.sort((a, b) => {
        // 首先比较价格
        const priceA = parseFloat(a[firstCondition]) || 0
        const priceB = parseFloat(b[firstCondition]) || 0

        // 如首要条件不相等，按价格从低到高排序
        if (priceA !== priceB) {
          return priceA - priceB
        }

        // 如果首要相等，比较次要（时效快的时间值小，排在前面）
        const timeA = parseFloat(a[secondCondition]) || 0
        const timeB = parseFloat(b[secondCondition]) || 0

        return timeA - timeB
      })

      return sortedArray
    },
    toIntroducePage (type) {
      this.$emit('toIntroducePage', type)
    },

    // 保价输入处理
    handleInputProtectPrice: debounce(function (event) {
      let value = event.target.value
      // 空值处理
      if (value === '') {
        this.protectPrice = ''
        return
      }
      this.protectPrice = value
      this.$nextTick(() => {
        // 格式化为最多两位小数
        let res = this.formatToTwoDecimals(value)
        if (parseFloat(res) && parseFloat(res) > 99999) {
          this.protectPrice = 99999
        } else {
          this.protectPrice = res
        }
      })
    }, 500),
    formatToTwoDecimals (value) {
      // 移除所有非数字和小数点的字符
      let cleaned = value.replace(/[^\d.]/g, '')

      // 处理开头的小数点，在前面加0
      if (cleaned.startsWith('.')) {
        cleaned = '0' + cleaned
      }

      // 处理多个小数点的情况
      const decimalParts = cleaned.split('.')
      if (decimalParts.length > 2) {
        cleaned = decimalParts[0] + '.' + decimalParts.slice(1).join('')
      }

      // 限制小数点后最多两位
      if (cleaned.includes('.')) {
        const parts = cleaned.split('.')
        if (parts[1].length > 2) {
          cleaned = parts[0] + '.' + parts[1].substring(0, 2)
        }
      }
      return cleaned
    },
    // 告诉外部组件修改了查询条件值函数
    changeQueryParam () {
      this.$emit('changeParam')
    }
  },
  created () {
    this.queryExchangeRate()
  }
}
</script>
<style scoped lang="scss">
@import './index.scss';
</style>
